import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  lookupUrl = '';

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) {
    this.lookupUrl = environment.lookupUrl;
  }

  getToken = () => localStorage.getItem('Token');

  getBusinessEntity = () => localStorage.getItem('namcvalue');

  getBusinessEntityName = () => localStorage.getItem('namcName');

  getUserRole = () => localStorage.getItem('UserRoles');

  getUserUPN = () => localStorage.getItem('UPN');

  getWorkID = () => localStorage.getItem('workdayId');

  getUserName = () => localStorage.getItem('UserName');

  getApiHeaders = () => {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: this.getToken(),
      'X-Api-Key': this.environment.lookupKey,
    });
  };

  httpCustomOptions = () => {
    return {
      params: {
        business_entity: this.getBusinessEntity(),
        user_role: this.getUserRole(),
        workid: this.getWorkID(),
      },
      headers: this.getApiHeaders(),
    };
  };
  httpCustomOptions1 = () => {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.getToken(),
        'X-Api-Key': this.environment.lookupKey,
      }),
    };
  };
  getLicenseKey(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/license`, this.httpCustomOptions());
  }

  getKanban(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/kanban`, this.httpCustomOptions()).pipe(catchError(error => of({ error })));;
  }

  getEasternDate(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/getEasternDate`, this.httpCustomOptions());
  }

  getContainer(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/container`, this.httpCustomOptions());
  }

  getPartNumber(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/partnumber`, this.httpCustomOptions()).pipe(catchError(error => of({ error })));
  }
  getDestCode(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/destcode`, this.httpCustomOptions()).pipe(catchError(error => of({ error })));;
  }
  getSupplier(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/supplier`, this.httpCustomOptions());
  }
  getDock(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/dock`, this.httpCustomOptions()).pipe(catchError(error => of({ error })));;
  }
  getSpecialist(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/specialist`, this.httpCustomOptions());
  }
  getAdjtype(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/adjtype`, this.httpCustomOptions());
  }
  getNotification(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/notification`, this.httpCustomOptions());
  }
  getNAMCList(): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/namclist`, this.httpCustomOptions());
  }
  getContact(data): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/getEmailId`, this.httpCustomOptions());
  }
  getBatchStatus(data): Observable<any> {
    return this.http.get<any>(`${this.lookupUrl}/getbatchstatus`, this.httpCustomOptions());
  }
  getVideos(data): Observable<any> {
    return this.http.post<any>(`${this.lookupUrl}/downloaTrainingvideos`, data, this.httpCustomOptions());
  }

  getReleaseNotes(data): Observable<any> {
    return this.http.post<any>(`${this.lookupUrl}/downloadReleaseNotes`, data, this.httpCustomOptions());
  }
  getUserManuals3Link(data): Observable<any> {
    return this.http.post<any>(
      `${this.lookupUrl}/downloadUserManual`,
    // 'http://localhost:3000/partcontList',
      data,
      this.httpCustomOptions()
    );
  }
  updateUserSession(action): Observable<any> {
    const data = {
      business_entity: this.getBusinessEntity(),
      business_entity_name: this.getBusinessEntityName(),
      userid: this.getUserUPN(),
      workid: this.getWorkID(),
      user_role: this.getUserRole(),
      action,
    };

    return this.http.post<any>(`${this.lookupUrl}/userSession`, data, this.httpCustomOptions());
  }

  getUserShowHideColumns(): Observable<any> {
    const data = {
      business_entity: this.getBusinessEntity(),
      business_entity_name: this.getBusinessEntityName(),
      userid: this.getUserName(),
      workid: this.getWorkID(),
      user_role: this.getUserRole(),
    };

    return this.http.post<any>(`${this.lookupUrl}/getShowHideColumns`, data, this.httpCustomOptions());
  }

  updateUserShowHideColumns(columns): Observable<any> {
    const data = {
      business_entity: this.getBusinessEntity(),
      business_entity_name: this.getBusinessEntityName(),
      userid: this.getUserName(),
      workid: this.getWorkID(),
      user_role: this.getUserRole(),
      ...columns,
    };

    return this.http.post<any>(`${this.lookupUrl}/updateShowHideColumns`, data, this.httpCustomOptions());
  }
  getqpcforpart(): Observable<any> {
    const data = {
      business_entity: this.getBusinessEntity(),
      business_entity_name: this.getBusinessEntityName(),
      userid: this.getUserName(),
      workid: this.getWorkID(),
      user_role: this.getUserRole(),
    };

    return this.http.post<any>(`${this.lookupUrl}/getqpcforpart`, data, this.httpCustomOptions()).pipe(catchError(error => of({ error })));
  }

    getqpcforpartWithMultiDestination(): Observable<any> {
    const data = {
      business_entity: this.getBusinessEntity(),
      business_entity_name: this.getBusinessEntityName(),
      userid: this.getUserName(),
      workid: this.getWorkID(),
      user_role: this.getUserRole(),
    };

    return this.http.post<any>(`${this.lookupUrl}/getQPCforPartwithDestCode`, data, this.httpCustomOptions()).pipe(catchError(error => of({ error })));
  }


  getDockInfo(moduleType): Observable<any> {
    const dockInfoUrl = `${this.lookupUrl}/dockinfo?module_type=${moduleType}`;
    return this.http.get<any>(dockInfoUrl, this.httpCustomOptions());
  }
  getInvReport(data): Observable<any> {
    return this.http.post<any>(
      `${this.lookupUrl}/invReportList`,
      data,
      this.httpCustomOptions1()
    );
  }
  
  downloadInvReport(data): Observable<any> {
    return this.http.post<any>(
      `${this.lookupUrl}/invDownloadmultipleReport`,
      data,
      this.httpCustomOptions1()
    );
  }
  getBatchTriggerNames(): Observable<any> {
    const data = {
      business_entity: this.getBusinessEntity(),
      business_entity_name: this.getBusinessEntityName(),
      userid: this.getUserName(),
      workid: this.getWorkID(),
      user_role: this.getUserRole(),
    };
    return this.http.post<any>(`${this.lookupUrl}/getBatchTriggerConfig`, data, this.httpCustomOptions1());
  }

  getBatcRunLog(data): Observable<any> {
    return this.http.post<any>(`${this.lookupUrl}/getrunLog`, data, this.httpCustomOptions1());
  }
  getLLPJob(data): Observable<any> {
    return this.http.post<any>(
      `${this.lookupUrl}/getinvjob`,
      data,
      this.httpCustomOptions1()
    );
  }

  // llp changes
  gets3linkLlp(data): Observable<any> {
    return this.http.post<any>(
      `${this.lookupUrl}/gets3linkLlp`,
    // 'http://localhost:3000/partcontList',
      data,
      this.httpCustomOptions()
    );
  }
  downloadReleaseNotesllp(data): Observable<any> {
    return this.http.post<any>(`${this.lookupUrl}/downloadReleaseNotesllp`, data, this.httpCustomOptions1());
  }


}
